import ClientCalendar from '../components/clientPortal/ClientCalendar';
import RecoveriesBanner from '../components/clientPortal/RecoveriesBanner';
import PWAInstallPrompt from '../components/clientPortal/PWAInstallPrompt';

const ClientCalendarPage = () => {
  return (
    <div className="flex flex-col w-full h-screen overflow-hidden">
      <main className="flex-1 overflow-y-auto px-4 pb-4 pt-24 w-full">
        <div className="w-full pb-24 space-y-6">
          <RecoveriesBanner />
          <ClientCalendar />
        </div>
      </main>
      <PWAInstallPrompt />
    </div>
  );
};

export default ClientCalendarPage;
